import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  jobStatusSucceeded: {
    id: '65cROr',
    defaultMessage: 'Succeeded',
    description: 'Job status succeeded',
  },
  jobStatusFailed: {
    id: 'NgKOz8',
    defaultMessage: 'Failed',
    description: 'Job status failed',
  },
  jobStatusRunning: {
    id: '0GlATG',
    defaultMessage: 'Running',
    description: 'Job status running',
  },
  jobStatusEnqueued: {
    id: 'EcKMhw',
    defaultMessage: 'Scheduled',
    description: 'Job status enqueued',
  },
});
